import { render, staticRenderFns } from "./addadmintrans.vue?vue&type=template&id=49a8834c&"
import script from "./addadmintrans.vue?vue&type=script&lang=js&"
export * from "./addadmintrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports